import NewBadge from './NewBadge'

const Item = ({ item, setModalOn, modalOn, singleItem, setSingleItem }) => {
  // تعطيل فتح صفحة الصنف
  const handleClick = () => {
    return; // لا تفعل شيئاً عند الضغط
  }

  return (
    <div
      onClick={!item.available ? undefined : handleClick}
      className={`w-full max-w-lg mx-auto rounded-2xl shadow-lg bg-white dark:bg-gray-800 overflow-hidden relative border border-gray-100 dark:border-gray-700 my-1 flex flex-col ${!item.available ? 'cursor-not-allowed select-none opacity-60' : 'cursor-pointer'}`}
   
    >
      {/* صورة الصنف */}
      <div className="w-full aspect-[4/3] bg-gray-100 dark:bg-gray-900 flex items-center justify-center overflow-hidden relative">
        {item.isNew ? <NewBadge /> : null}
        <img
          className="w-full h-full object-cover object-center"
          src={item.image}
          alt={item.title}
        />
      </div>
      {/* محتوى البطاقة */}
      <div className="p-3 flex flex-col gap-2 items-center justify-center w-full">
        {/* الاسم بالعربي والانجليزي */}
        <div className="flex flex-row items-center gap-2 justify-center w-full">
          <span className="text-base text-primaryGreen-500 font-semibold dark:text-white">{item.title}</span>
          {item.titleEn && (
            <span className="text-base text-gray-500 dark:text-gray-300">| {item.titleEn}</span>
          )}
        </div>
        {/* الوصف */}
        {item.description && (
          <p className="text-center text-sm text-gray-800 dark:text-gray-300 leading-relaxed line-clamp-3 w-full">
            {item.description}
          </p>
        )}
        {/* الإضافات */}
        {item.additions && item.additions.length > 0 && (
          <div className="flex flex-wrap gap-1 justify-center w-full ">
            {item.additions.map((add, idx) => (
              <span key={idx} className="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-xs rounded-full text-gray-800 dark:text-white dark:border-gray-600 shadow-xs">{add}</span>
            ))}
          </div>
        )}
      </div>
      {/* الخط والسعر والسعرات في الأسفل دائماً */}
      <div className="w-full mt-auto px-3 pb-3">
        <div className="w-full border-t border-gray-200 dark:border-gray-700 mb-2"></div>
        <div className="flex flex-row justify-between items-center w-full pt-1">
          {item.calories ? (
            <span className="text-sm text-gray-800 dark:text-white ">
              سعرات حرارية : <span className="">{item.calories}</span>
            </span>
          ) : <span />}
          <span className="text-sm flex items-center font-bold text-main-900 dark:text-white">
            {item.price.toLocaleString('en-US')}
            <span className="text-primaryGreen-500 dark:text-white text-sm font-semibold mx-1">ريال</span>
          </span>
        </div>
      </div>
      {/* علامة غير متوفر */}
      {!item.available ? (
        <div className='absolute inset-0 w-full h-full z-[50] text-center flex flex-col items-center justify-center backdrop-blur-[2px] bg-[#597c80]/40 dark:bg-gray-800/60 font-bold rounded-2xl select-none'>
          <div className="bg-red-500/80 dark:bg-red-600/80 px-6 py-2 rounded-full transform -rotate-12 shadow-lg">
            <span className="text-white text-xl">غير متوفر</span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default Item
